import { render, staticRenderFns } from "./PageOnboarding.vue?vue&type=template&id=73874827&scoped=true&"
import script from "./PageOnboarding.vue?vue&type=script&lang=js&"
export * from "./PageOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./PageOnboarding.vue?vue&type=style&index=0&id=73874827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73874827",
  null
  
)

export default component.exports